import { PlantGrowth } from "../../../../../api/types/plants";
import { CafsVariable } from "../../../../../types/cafs-variable";
import { SelectOption } from "../../../../../types/select-option";
import { useTreeHabitData } from "../../../api/useTreeHabitData";
import { useVegetationLayer } from "../../../api/useVegetationLayer";
import { CafsVariableType } from "../../../const/cafs-variable-type";
import { renderForTree } from "../../../utils/render-for-tree";

import { heightMaxGrowPMonthFn } from "./functions/heightMaxGrowPMonthFn";
import { offSeasonCanopyCoverReductionFn } from "./functions/offSeasonCanopyCoverReductionFn";
import { rusleFactorFn } from "./functions/RusleFactorFn";

export function useGrowthVariables(): CafsVariable<PlantGrowth>[] {
  const { treeHabit } = useTreeHabitData();
  const { vegetationLayers } = useVegetationLayer();

  return [
    {
      name: "GrowthRemarks",
      type: CafsVariableType.Remarks,
    },
    {
      name: "VegetationLayerId",
      type: CafsVariableType.Select,
      options: vegetationLayers?.map(vl => {
        return { label: vl.Name, id: vl.Id } as SelectOption;
      }),
    },
    {
      name: "MaxHeightM",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "MinYearsToMaxHeight",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "HeightMaxGrowthPMonth",
      type: CafsVariableType.Calculated,
      calculationFn: heightMaxGrowPMonthFn,
      dependOn: ["MaxHeightM", "MinYearsToMaxHeight"],
      shouldRender: renderForTree,
    },
    {
      name: "EffectSuitabilityOnGrowth",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "EffectAgeOnGrowth",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "CanopyMaxGrowthPYearM",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "TreeCrownDiameterNaturalM",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "TreePlantingDistanceM",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "TreeRowWidthM",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "TreeStripDistanceM",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "NoOfTreeRowsPerStrip",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "TreeToppingHeightM",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "CanopyRadiationInterception",
      type: CafsVariableType.Input,
    },
    {
      name: "MeanAnnualIncrementMaxM3PY",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "TreeHabitId",
      type: CafsVariableType.Select,
      options: treeHabit?.map(vl => {
        return { label: vl.Name, id: vl.Id } as SelectOption;
      }),
      shouldRender: renderForTree,
    },
    {
      name: "OffSeasonCanopyCoverReduction",
      type: CafsVariableType.Calculated,
      dependOn: ["TreeHabitId"],
      calculationFn: offSeasonCanopyCoverReductionFn,
      data: treeHabit,
      shouldRender: renderForTree,
    },
    {
      name: "CanopyFractionOfTotalHeight",
      type: CafsVariableType.Input,
    },
    {
      name: "PruningAffectsCanopyCover",
      type: CafsVariableType.Boolean,
    },
    {
      name: "PruningQuantityValueUpliftFraction",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "PruningQualityValueUpliftFraction",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "OptimumPruningFraction",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "NeutralPruningFraction",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "PruningOptimumEffectDurationMonths",
      type: CafsVariableType.Input,
      shouldRender: renderForTree,
    },
    {
      name: "RusleCFactor",
      type: CafsVariableType.Input,
    },
    {
      name: "RuslePFactor",
      type: CafsVariableType.Input,
    },
    {
      name: "RusleFactor",
      type: CafsVariableType.Calculated,
      calculationFn: rusleFactorFn,
      dependOn: ["RusleCFactor", "RuslePFactor"],
    },
  ];
}
